import { Button, Stack } from "@mui/material";
import React from "react";
import Img1 from "./section2Image.png";
import Img2 from "./main2.png";
import backImg1 from "./heroImgBackground.png";
import VideoCard from "../Section10/Section10";
import Section2 from "../Section2/Section2";
import Section11 from "../Section11/Section11";
import RevenueDetails from "./RevenueTextSlider/RevenueDetails";
import IntroTextSlider from "./IntroTextSlider/IntroTextSlider";

const MainSection2 = () => {
  return (
    <>
      <Stack sx={{ height: "auto" }}>
        <Stack
          sx={{
            // backgroundColor: "#405e6e",
            // backgroundColor: "#b9c7bd",
            // backgroundColor: "#9fb7d1",
            backgroundColor: "#ebf4ff",
            // backgroundColor: "#405e6e",
            // backgroundColor: "#02527d",

            // background: "linear-gradient(90deg, #002e4d 0%, #0070c0 100%)",

            // backgroundImage: `url(${backImg1})`,
            // backgroundSize: "cover",
            // backgroundPosition: "center",
            // border: "2px solid red",
            height: "auto",
            color: "white",
          }}
        >
          <IntroTextSlider />

          <VideoCard />

          <RevenueDetails />

          <Section11 />
        </Stack>
      </Stack>
    </>
  );
};

export default MainSection2;
